// @flow
import modularui from "../_modularui/ModularUIConnector";

import type { ModularUIConnector } from "../_modularui/types";

/**
 * @deprecated - will be removed in the future, use the equivalent hook 'useContentIndex' instead
 */
export const connectContentBrowser: ModularUIConnector = modularui(
  "ContentBrowser",
  ({ href }) => href,
  {
    propName: "contentindex",
  },
);
